import { render, staticRenderFns } from "./CouponCta.vue?vue&type=template&id=33cd1cb6&"
import script from "./CouponCta.vue?vue&type=script&lang=js&"
export * from "./CouponCta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports